import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import FileService from '../../../api/services/FileService';
const ACTIONS_PREFIX = 'messages/compose';

interface ComposeState {
  isLoading: boolean;
  error?: string;
}

const initialState = {
  isLoading: false,
};

export const uploadMessageAttachmentsThunk = createAsyncThunk(
  `${ACTIONS_PREFIX}/uploadMessageAttachments`,
  FileService.uploadMessageAttachments,
);

const composeSlice = createSlice({
  name: 'compose',
  initialState: initialState as ComposeState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(uploadMessageAttachmentsThunk.pending, (state) => {
        state.isLoading = true;
        state.error = undefined;
      })
      .addCase(uploadMessageAttachmentsThunk.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(uploadMessageAttachmentsThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export default composeSlice.reducer;
